/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Form_SubtitleInputs */

const en_site_form_subtitle = /** @type {(inputs: Site_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep reads the site's public pages, maps its features, flows, pricing and technology, then interviews you to decide your own version — not a copy.`)
};

const id_site_form_subtitle = /** @type {(inputs: Site_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep membaca halaman publik situs itu, memetakan fitur, alur, harga, dan teknologinya, lalu mewawancaraimu untuk memutuskan versi milikmu — bukan menyalinnya.`)
};

/**
* | output |
* | --- |
* | "Bystep reads the site's public pages, maps its features, flows, pricing and technology, then interviews you to decide your own version — not a copy." |
*
* @param {Site_Form_SubtitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_form_subtitle = /** @type {((inputs?: Site_Form_SubtitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Form_SubtitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_form_subtitle(inputs)
	return en_site_form_subtitle(inputs)
});